// @flow
import type { ProductState, ProductAction } from 'stores/flow-type/product.type';

import {
  GET_PRODUCTS_REQUEST,
  GET_PRODUCTS_SUCCESS,
  GET_PRODUCTS_FAILURE,
  SEARCH_PRODUCTS_REQUEST,
  SEARCH_PRODUCTS_SUCCESS,
  SEARCH_PRODUCTS_FAILURE,
  GET_PREVIEW_PRODUCTS_REQUEST,
  GET_PREVIEW_PRODUCTS_SUCCESS,
  GET_PREVIEW_PRODUCTS_FAILURE,
  RESET_PRODUCT_LIST,
  UPDATE_RECOMMEND_PRODUCTS,
  GET_PRODUCTS_BY_COLLECTION_IDS_REQUEST,
  GET_PRODUCTS_BY_COLLECTION_IDS_SUCCESS,
  GET_PRODUCTS_BY_COLLECTION_IDS_FAILURE,
} from 'stores/flow-type/product.type';

const initialState: ProductState = {
  loading: false,
  success: false,
  error: undefined,
  products: [],
  total: 0,
  searchProducts: [],
  productData: {},
  totalProducts: 0,
  affectPerformanceRanking: true,
  affectMerchandising: false,
  productsByCollection: [],

  recommendProducts: {}
};

const productsReducers = (state: ProductState = initialState, action: ProductAction) => {
  switch (action.type) {
    case GET_PRODUCTS_REQUEST:
    case SEARCH_PRODUCTS_REQUEST:
    case GET_PREVIEW_PRODUCTS_REQUEST:
      return { ...state, loading: true, success: false };

    case GET_PRODUCTS_SUCCESS:
    case GET_PREVIEW_PRODUCTS_SUCCESS: {
      const { data: products = [], total = 0, shop = {} } = action.payload || {};
      return {
        ...state,
        loading: false,
        success: true,
        error: undefined,
        products,
        shop,
        total
      };
    }

    case SEARCH_PRODUCTS_SUCCESS: {
      const {
        products = [],
        total_product = 0,
        affected_by_performance_ranking = true,
        affected_by_merchandising = false
      } = action.payload || {};
      return {
        ...state,
        loading: false,
        success: true,
        error: undefined,
        searchProducts: products,
        productData: action.payload,
        totalProducts: total_product,
        affectPerformanceRanking: affected_by_performance_ranking,
        affectMerchandising: affected_by_merchandising
      };
    }
    case GET_PRODUCTS_FAILURE:
    case SEARCH_PRODUCTS_FAILURE:
    case GET_PREVIEW_PRODUCTS_FAILURE:
      return {
        ...state,
        loading: false,
        saving: false,
        success: false,
        error: action.payload
      };
    case RESET_PRODUCT_LIST:
      return {
        ...state,
        products: [],
        shop: '',
        total: 0
      };

    case UPDATE_RECOMMEND_PRODUCTS: {
      const { products } = action.payload || {};

      return {
        ...state,
        recommendProducts: products
      };
    }

    case GET_PRODUCTS_BY_COLLECTION_IDS_REQUEST:
    case GET_PRODUCTS_BY_COLLECTION_IDS_FAILURE:
      return { ...state, productsByCollection: [] };

    case GET_PRODUCTS_BY_COLLECTION_IDS_SUCCESS: {
      const { data: productsByCollection = [] } = action.payload || {};
      return {
        ...state,
        loading: false,
        success: true,
        error: undefined,
        productsByCollection
      };
    }

    default:
      return state;
  }
};
export default productsReducers;
